import React from 'react'
import cx from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconDefinition } from '@fortawesome/free-solid-svg-icons'
import { IconDefinition as BrandIconDefinition } from '@fortawesome/free-brands-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

type IconProps = {
    icon: IconDefinition | BrandIconDefinition
    classes?: string
    onClick?: () => void
    size?: string
    color?: string
    title?: string
}

const Icon: React.FC<IconProps> = ({ icon, classes, onClick, size, color, title }) => {
    return (
        <FontAwesomeIcon
            title={title}
            icon={icon as IconProp}
            className={cx(classes)}
            style={{ fontSize: size, color: color, fill: color }}
            onClick={onClick}
        />
    )
}

export default Icon
